import type { ThemeOptions } from '@mui/material'
import { commonPaletteColors } from './palette-common'

/**
 * NOTE: Please consider adding the new colors and palette section at the end of file
 *       Preventing design team conflicts
 */
export const lightPalette: ThemeOptions['palette'] = {
  mode: 'light',
 
  line: {
    primary: '#ECF1F9',
    secondary: '#BCC9DC',
    tertiary: '#8D9FB9',
  },
  primary: {
    lighter: '#E2E9F3',
    light: '#5979A6',
    main: '#007AFF',
    dark: '#007affd1',
    darker: '#061B37',
    overlay: '#E5F0FF',
  },
  secondary: {
    lighter: '#EBF3FF',
    light: '#4C9AFF',
    main: '#171D26',
    dark: '#171d26d6',
    darker: '#0F3E80',
    overlay: '#FFFFFF',
  },
  tertiary: {
    lighter: '#FFF0E4',
    light: '#FFF0E4',
    main: '#E26C2B',
    dark: '#E26C2B',
    darker: '#E26C2B',
    overlay: '#FFF0E4',
    contrastText: "#ffffff",
  },
  success: {
    lighter: '#E5FAF3',
    light: '#8CD9BF',
    main: '#34B288',
    dark: '#008055',
    darker: '#006644',
    overlay: '#EEFCF7',
  },
  error: {
    lighter: '#FFEBEE',
    light: '#E4677C',
    main: '#EB4763',
    dark: '#D22D48',
    darker: '#8F2436',
    overlay: '#FFF5F7',
  },
  warning: {
    lighter: '#FFF2E0',
    light: '#FFC066',
    main: '#FF9500',
    dark: '#FF8C00',
    darker: '#4D2600',
    overlay: '#FFFCF5',
  },
  info: {
    lighter: '#EBF3FF',
    light: '#4C9AFF',
    main: '#007AFF',
    dark: '#0E54B7',
    darker: '#0F3E80',
    overlay: '#FFFFFF',
  },

  // New Design System 
  text: {
    text:`#252525`, 
    text2: 'rgba(0, 0, 0, 0.60)',
    text3: 'rgba(0, 0, 0, 0.40)',
    text4: 'rgba(0, 0, 0, 0.20)',



    primary: '#252525',//TODO 
    secondary: '#476185',
    warning: '#A06F0C',
    tertiary: '#8D9FB9',
    disabled: '#C6CBD2',
  },
  grad:"FFFFFF",
  onNegative: {
    text:'#FFFFFF',
    text2: 'rgba(0, 0, 0, 0.60)',
  
    bg: '#171D26', 
  },
  stroke: {
    stroke: 'rgba(0, 0, 0, 0.02)', 
    stroke2: 'rgba(0, 0, 0, 0.05)', 
    stroke3: 'rgba(0, 0, 0, 0.1)', 
    stroke4: 'rgba(0, 0, 0, 0.2)', 
    stroke5: 'rgba(0, 0, 0, 0.6)', 
  }, 
  primaryBrand: {
    text:'#007AFF',
    text2: '#4DA2FF ',
  
    bg: '#007AFF', 
    bg2: '#3395FF', 
    bg3: '#99CAFF', 
    bg4: '#E5F2FF', 
    bg5: '#F2F8FF',


    stroke: '#007AFF', 
    stroke2: '#66AFFF', 
    stroke3: '#CCE4FF', 
    stroke4: '#E5F2FF', 
    
    grad: {
      main: '#007AFF',
      dark: '#0752A5'
    }

  },

  onColor: {
    text:'#FFFFFF',
    text2: 'rgba(255, 255,  255, 0.80)',
    text3: 'rgba(0, 0, 0, 0.60)',
  },

  approve: { 
    text:'#03904E',
 
  
    bg: '#00AF5A', 
    bg2: '#33BF7B', 
    bg3: '#E5F7EE', 
    bg4: '#F2FBF6', 



    stroke: '#00AF5A', 
    stroke2: '#66CF9C', 
    stroke3: '#CCEFDE', 
   
  
  },
  warning__wallfund: {
    text:'#A06F0C',
 
  
    bg: '#FFD400', 
    bg2: '#FFF6CC', 
  

  
  },
  critical: {
    text:'#D9151C',
    text2:'#F06B70 ',
  
    bg: '#D13438', 
    bg2: '#DA5D60', 
    bg3: '#FAEBEB', 
    bg4: '#FDF5F5', 
    bg5: '#FEFBFB', 
  
    stroke: '#D13438', 
    stroke2: '#EDAEAF', 
    stroke3: '#FAEBEB', 
  
  },

    // New Design System
    glass: {
      bg: 'rgba(0, 0, 0, 0.05)',
      primary: {
        bg: 'rgba(0, 122, 255, 0.05)',
        bg2: 'rgba(0, 122, 255, 0.1)'
      },
      negative: 'rgba(0, 0, 0, 0.02)'
    },
    // New Design System 
    glassOnColor: {
      bg: 'rgba(255, 255, 255, 0.10)'
    },
    shell: '#D7DADF',
    smoke: 'rgba(0, 0, 0, 0.40)',

    hover__Wallfund: 'rgba(0, 0, 0, 0.05)',
    press: 'rgba(0, 0, 0, 0.10)',

  // New Design System 
  background: {
    bg: '#FFFFFF',
    bg2: '#FAFBFC',
    bg3: '#F2F4F7',
    bg4: '#D7DADF',
    hover:'rgba(0, 0, 0, 0.05)',
    press:'rgba(0, 0, 0, 0.1)',

    bg5: '#F3F7FE',
    default: '#F4F7FB',
    paper: '#FFFFFF',

    warning: {
      bg3: '#FDF8EB'
    },

    golden: {
      dark: '#CF8C06',
    },
    
  },
  neutral:{
    bg2: '#FBFBFC',
    bg3: '#F5F6F7'
  },
 

  
  common: commonPaletteColors,
}
